exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coordinators-wrapper[data-v-d9030aa2]{max-width:1130px;margin:0 auto;padding:30px 20px}@media only screen and (min-width:40.0625em){.coordinators-wrapper[data-v-d9030aa2]{padding:30px 40px}}.coordinators-wrapper .coordinators-box[data-v-d9030aa2]{display:-ms-grid;display:grid;grid-auto-rows:1fr;grid-gap:20px;overflow:hidden}@media only screen and (min-width:40.0625em){.coordinators-wrapper .coordinators-box[data-v-d9030aa2]{max-height:80px;-ms-grid-rows:(100%)[auto-fit];grid-template-rows:repeat(auto-fit,100%);-ms-grid-columns:(minmax(calc(100% / 6 - 20px),1fr))[auto-fit];grid-template-columns:repeat(auto-fit,minmax(calc(100% / 6 - 20px),1fr))}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d9030aa2","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/footer/coordinators/CoordinatorsBox.vue
// module id = 6e8f4147348ef37253d7
// module chunks = 0